import { lazy } from 'react';

const ProductView = lazy(() => import('./ProductView'));

export default ProductView;
